module.exports = __webpack_public_path__ + "static/img/virtualReality3.d19d9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/virtualReality3.png
// module id = WJxV
// module chunks = 13